import { OnboardingPhases } from 'core/models/users/user.model';
import { ROUTES } from 'routes';

export const MAP_ONBOARDING_PHASE_TO_ROUTE: Record<OnboardingPhases, string> = {
  [OnboardingPhases.SIGNUP]: ROUTES.ONBOARDING,
  [OnboardingPhases.USER_APPLICATION_SUBMITTED]: ROUTES.APPLICATION_IN_REVIEW,
  [OnboardingPhases.ADMIN_APPROVED]: ROUTES.APPLICATION_IN_REVIEW,
  [OnboardingPhases.KYC_APPROVED]: ROUTES.DASHBOARD,
  [OnboardingPhases.MINT_NFT]: ROUTES.DASHBOARD,
  [OnboardingPhases.DONE]: ROUTES.DASHBOARD,
};
